import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GetProductAvailabilityInStoresDataPromise, queryDTO } from './TypePromise';
import config from '@app/config';
import { defaultHeaders } from '@redux/api/Config';
import { ReturnFetchAvailabilityProductPromise } from '@entities/Shop/module/types/availabilityProductSchema';
import { fetchAvailabilityProductDto } from '@entities/Shop/module/services/dto';

export const productAvailabilityInTheStoresApi = createApi({
  reducerPath: 'productAvailabilityInTheStoresApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: defaultHeaders,
  }),
  endpoints: builder => ({
    getProductAvailabilityInStores: builder.query<GetProductAvailabilityInStoresDataPromise, queryDTO>({
      query: ({ productRN, regionId, part }) => `/api/products/${productRN}/overall-availability?regionId=${regionId}&part=${part}`,
      transformResponse: (response: { data }): GetProductAvailabilityInStoresDataPromise => response.data,
    }),
    getProductAllAvailability: builder.query<ReturnFetchAvailabilityProductPromise, fetchAvailabilityProductDto>({
      query: ({ productRN, regionId, part }) => `/api/products/${productRN}/availability?part=${part}&regionId=${regionId}`,
      transformResponse: (response: { data }): ReturnFetchAvailabilityProductPromise => response.data,
    }),
  }),
});

export const { useGetProductAvailabilityInStoresQuery, useGetProductAllAvailabilityQuery, endpoints } = productAvailabilityInTheStoresApi;
